<template>
  <svg width="100%"
       height="36px" style="display: block" >
    <g v-for="vente in ventes" :key="vente.key" :ref="vente.key" @click="ajouterAuPanier(vente)"
      v-bind:class="{'pointer': typeVente != sansTypeVente}">
      <rect
        :x="vente.x1WithPaddingString" y="0" :width="vente.widthWithPaddingString"
        rx="2" ry="2" height="100%"
        :stroke="vente.stroke" stroke-width="2" :fill="vente.fill"/>
      <text v-if="vente.texte"
        :x="vente.xmilieuWithPaddingString" y="50%" dominant-baseline="central" text-anchor="middle"
        font-size="14" fill="black">{{ vente.texte }}</text>
    </g>
  </svg>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import decorateurRectanglePanneauxNumeriques from '@/services/decorateur/decorateurRectanglePanneauxNumeriques';
import decorateurRectanglePanneauxNumeriquesVente from '@/services/decorateur/decorateurRectanglePanneauxNumeriquesVente';
import { GRANULARITY, GRANULARITY_DAY, SANS_TYPE_VENTE } from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';

const VenteNumerique = createNamespacedHelpers('venteNumerique');

export default {
  props: ['data', 'index'],
  data() {
    return {
      sansTypeVente: SANS_TYPE_VENTE,
      dataSelectionAccess: {},
      granularityDay: GRANULARITY[GRANULARITY_DAY],
    };
  },
  computed: {
    ...VenteNumerique.mapGetters({
      criterePlanning: 'criterePlanning',
      getTypeVente: 'typeVente',
    }),
    ventes() {
      const ventesArray = [];
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateStart.clone().add(this.criterePlanning.days, 'days');
      for (const m = moment(dateStart); m.diff(dateEnd, 'days') <= 0; m.add(1, 'days')) {
        const result = getRectangle(this.criterePlanning, m, m);
        if (result !== null) {
          const key = `r${this.data.num}${m.format('YYYYMMDD')}`;
          if (this.dataSelectionAccess[key]) {
            result.selectionne = this.dataSelectionAccess[key];
          }
          decorateurRectanglePanneauxNumeriques(result, this.data.faces, m, m);
          decorateurRectanglePanneauxNumeriquesVente(result, this.data.num, m, GRANULARITY_DAY);
          ventesArray.push(result);
        }
      }
      return ventesArray;
    },
    typeVente: {
      get() {
        return this.getTypeVente;
      },
      set(value) {
        this.setTypeVente(value);
      },
    },

  },
  methods: {
    ...VenteNumerique.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteNumerique.mapMutations({
      setPanneauSelected: types.SET_PANNEAU_SELECTED,
      setTypeVente: types.SET_TYPE_VENTE,
    }),
    ajouterAuPanier(vente) {
      this.typeVente = 100;
      const tarification = this.typeVente + this.granularityDay.value;
      this.setPanneauSelected({
        panNum: vente.panNum,
        value: true,
      });
      this.$set(this.dataSelectionAccess, vente.key, this.typeVente);
      this.actionsGestionPanier({
        panNum: vente.panNum,
        periode: vente.periode,
        tarification: tarification,
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/planningNumeriqueJourSvg.vue